import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { useAuth } from '../modules/authentication/context/AuthContext';


interface AppContextType {

  isAdmin: boolean;
  isUser: boolean;
  isAdminOrUser: boolean;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

interface AppProviderProps {
  children: ReactNode;

}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const { user } = useAuth();
  const isAdmin = useMemo(() => user?.type === 'admin', [user?.type]);
  const isUser = useMemo(() => user?.type === 'user', [user?.type]);
  const isAdminOrUser = useMemo(() => user?.type === 'admin' || user?.type === 'user', [user?.type]);

  const value = useMemo<AppContextType>(() => ({
    isAdmin,
    isUser,
    isAdminOrUser
  }), [isAdmin, isUser, isAdminOrUser]);

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};
